import React from "react";

import itImage from "../assets/it.png";
import sportsImage from "../assets/sports.png";
import eventsImage from "../assets/events.png";

const SegmentsSection = () => {
  return (
    <section className="segments-section">

      <div className="segments-wrapper">

        {/* IT CARD */}

        <div className="segment-card side-card">

          <img src={itImage} className="segment-icon" alt="IT" />

          <h2>IT & Tech</h2>

          <p>
            Delivering scalable technology
            solutions that drive innovation
            and business growth.
          </p>

          <button className="segment-btn">
            Explore More
          </button>

        </div>


        {/* SPORTS CARD */}

        <div className="segment-mcard center-card">

          <img src={sportsImage} className="segment-icon sports-icon" alt="Sports" />

          <h2>Sports</h2>

          <p>
            Creating impactful digital experiences
            that strengthen engagement across
            the sports ecosystem.
          </p>

          <button className="segment-btn">
            Explore More
          </button>

        </div>


        {/* EVENTS CARD */}

        <div className="segment-card side-card">

          <img src={eventsImage} className="segment-icon" alt="Events" />

          <h2>Events</h2>

          <p>
            Designing seamless digital solutions
            that enhance event management & Audience Engagement.
          </p>

          <button className="segment-btn">
            Explore More
          </button>

        </div>

      </div>

    </section>
  );
};

export default SegmentsSection;